import Vue from "vue";

export default (context) =>
  // context.code,
  Vue.$http
    .post("/airbnb/send-connection-link", {
      email: context.email_another_account_airbnb,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.log(error.response.data, "[GET] /airbnb/user-create");
      toastr.error(error.response.data.msg);
    })
    .finally(() => {});



// WEBPACK FOOTER //
// ./src/app/services/airbnb/send-email.js